import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../supabaseClient'
import {
  widgetCardStyle,
  labelStyle,
  footerStyle,
} from '../styles/widgetStyles'

function LatestUploadedPlans() {
  const [plans, setPlans] = useState([])
  const [hover, setHover] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchPlans = async () => {
      const { data, error } = await supabase
        .from('plans_test')
        .select('group_name, group_id, last_upload_date')
        .order('last_upload_date', { ascending: false })
        .limit(3)

      if (!error) setPlans(data || [])
    }

    fetchPlans()
  }, [])

  return (
    <div
      style={widgetCardStyle(hover, true)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => navigate('/plans-by-group')}
    >
      <div style={{ width: '100%', maxWidth: '260px', textAlign: 'center' }}>
        <div style={labelStyle}>
          🆕 Latest Uploaded Plans{' '}
          <span title="Most recently uploaded plans.">ℹ️</span>
        </div>

        <ul style={{ listStyle: 'none', padding: 0, margin: '0.5rem 0' }}>
          {plans.length === 0 ? (
            <li style={{ fontSize: '0.9rem', color: '#6b7280' }}>
              No recent uploads
            </li>
          ) : (
            plans.map((plan, idx) => (
              <li
                key={idx}
                style={{
                fontSize: '0.875rem',
                marginBottom: '0.4rem',
                paddingBottom: '0.4rem',
                color: '#1f2937',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
                textAlign: 'center',
                borderBottom: idx !== plans.length - 1 ? '1px solid #e5e7eb' : 'none',
                }}
              >
              {plan.group_name || 'Unnamed Plan'}{' '}
              <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
              ({new Date(plan.last_upload_date).toLocaleDateString()})
              </span>
            </li>

            ))
          )}
        </ul>

        <div style={footerStyle}>Click to view all plans</div>
      </div>
    </div>
  )
}

export default LatestUploadedPlans
